import React from "react";
import ProductManagement from "../../page/AdminManager/ProductManagement";
import NewsManagement from "../../page/AdminManager/NewsManagerment";
import ShipManagement from "../../page/AdminManager/ShipManagement";
import TypeProductManagement from "../../page/AdminManager/TypeProductManagement";
import VoucherManagement from "../../page/AdminManager/VoucherManagement";
import OrderManagement from "../../page/AdminManager/OrderManagement";
import TransactionManagement from "../../page/AdminManager/TransactionManagement";
import UserManagement from "../../page/UserManager/UserManagement";

const PageContent = ({ activePage }) => {
  switch (activePage) {
    case "dashboard":
      return <h2>📊 Dashboard</h2>;
    case "news":
      return <NewsManagement />;
    case "list-product":
      return <ProductManagement />;
    case "product-types":
      return <TypeProductManagement/>
    case "shipping":
      return <ShipManagement/>
      case "voucher":
        return <VoucherManagement/>
        case "order":
          return <OrderManagement/>
        case "transaction":
          return <TransactionManagement/> 
          case "users":
            return <UserManagement/> 
    default:
      return <h2>Chọn một mục từ sidebar</h2>;
  }
};

export default PageContent;
